var _desc, _defs;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgShoppingBag = function SvgShoppingBag(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 1.7.22")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    transform: "translate(128 128) scale(0.72 0.72)",
    style: {}
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(-175.05 -175.05000000000004) scale(3.89 3.89)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 73.903 63.178 H 28.899 c -4.566 0 -8.377 -3.276 -9.063 -7.79 l -5.662 -37.261 c -0.087 -0.576 0.081 -1.162 0.461 -1.604 s 0.934 -0.696 1.517 -0.696 h 67.893 c 1.805 0 3.491 0.805 4.628 2.208 c 1.135 1.403 1.571 3.22 1.195 4.985 l -6.999 32.899 C 81.975 60.125 78.203 63.178 73.903 63.178 z M 18.479 19.827 l 5.313 34.96 c 0.386 2.544 2.534 4.391 5.107 4.391 h 45.004 c 2.424 0 4.549 -1.721 5.054 -4.091 l 6.999 -32.9 c 0.123 -0.58 -0.02 -1.176 -0.393 -1.636 c -0.373 -0.46 -0.926 -0.725 -1.519 -0.725 H 18.479 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 16.15 19.827 c -0.988 0 -1.848 -0.732 -1.98 -1.738 l -0.598 -4.531 c -0.279 -2.116 -2.099 -3.712 -4.233 -3.712 H 2 c -1.104 0 -2 -0.896 -2 -2 s 0.896 -2 2 -2 h 7.339 c 4.133 0 7.658 3.09 8.199 7.188 l 0.598 4.531 c 0.145 1.095 -0.626 2.1 -1.721 2.245 C 16.325 19.821 16.237 19.827 16.15 19.827 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 29.18 84.154 c -4.76 0 -8.632 -3.873 -8.632 -8.633 s 3.873 -8.632 8.632 -8.632 c 4.76 0 8.633 3.872 8.633 8.632 S 33.94 84.154 29.18 84.154 z M 29.18 70.89 c -2.554 0 -4.632 2.078 -4.632 4.632 c 0 2.555 2.078 4.633 4.632 4.633 c 2.555 0 4.633 -2.078 4.633 -4.633 C 33.813 72.968 31.734 70.89 29.18 70.89 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 71.339 84.154 c -4.76 0 -8.633 -3.873 -8.633 -8.633 s 3.873 -8.632 8.633 -8.632 s 8.632 3.872 8.632 8.632 S 76.099 84.154 71.339 84.154 z M 71.339 70.89 c -2.555 0 -4.633 2.078 -4.633 4.632 c 0 2.555 2.078 4.633 4.633 4.633 c 2.554 0 4.632 -2.078 4.632 -4.633 C 75.971 72.968 73.893 70.89 71.339 70.89 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgShoppingBag, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/shopping-bag.8be94008.svg";
export { ForwardRef as ReactComponent };